angular = require( 'angular' )

app = angular.module( 'workflow.app' )
app.directive( 'sourceContainer', require( './SourceContainer.dir' ))
